export default "__VITE_ASSET__CZ$GiVOO__"